WiseMetering.Views.NewMeasurablConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/measurabl/new',
    title: () => i18next.t('modal.title.integration_configurations.new'),
    ui: {
        sites: '#integration_configuration_site_id'
    },

    onShow: function() {
        const
            usedSiteIds = this.model.license().configurations().pluck('site_id'),
            sites = WiseMetering.zones.activeSites().models.filter(site => !usedSiteIds.includes(site.id));

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites));
    }
});
